// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","container":"container-3lVdh","route":"route-340Og","thumbnail":"thumbnail-1hLzn","summary":"summary-6Szga","details":"details-2tbhR","dateActivity":"dateActivity-3-lqy","detailLabel":"detailLabel-1jSw5","detailVal":"detailVal-avP4n","calorieDetails":"calorieDetails-KnfAV","name":"name-2gMnw","distanceContainer":"distanceContainer-sJKQS","distance":"distance-IDJgd","date":"date-2fPzC","iconContainer":"iconContainer-3T-13","activityIcon":"activityIcon-1-naT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/workouts/_workout.css
// module id = 1221
// module chunks = 1